import { render } from "./EquitySubledger.vue?vue&type=template&id=5ac2ef57"
import script from "./EquitySubledger.vue?vue&type=script&lang=js"
export * from "./EquitySubledger.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__